import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'modulo-evento',
  templateUrl: './evento.component.html',
  styleUrls: ['./evento.component.scss']
})
export class EventoComponent implements OnInit {

  @Input("data") data:any     = null; 
  @Input("template") template = null;
 
  constructor() { }

  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{}

}
